import svgForEveryBody from 'svg4everybody';
import SlimSelect from 'slim-select';
import Lightpick from 'lightpick';
import Swiper, {Navigation, Grid} from 'swiper';

// Svg sprites for all
svgForEveryBody();

// Toggle nav
const hamburger = document.querySelector('.header__hamburger');
const nav = document.querySelector('.header__nav');
hamburger.addEventListener('click', function () {
    hamburger.classList.toggle('open');
    nav.classList.toggle('open');
});

// Footer nav toggle
const footerNavTitle = document.querySelectorAll('.footer__widget-title');
footerNavTitle.forEach(function (item) {
    item.addEventListener('click', function () {
        item.parentElement.classList.toggle('open');
    });
});

// Custom selects
const select = document.querySelectorAll('select');
select.forEach(function (item) {
    new SlimSelect({
        select: item,
        showSearch: item.dataset.search ? item.dataset.search : false,
        searchText: "Результатов не найдено",
        searchPlaceholder: "Найти",
        placeholder: true,
    })
});

// Tabs
const tabs = document.querySelectorAll('.tabs, [data-tabs]');
tabs.forEach(function (tab) {
    let toggles = tab.querySelectorAll('.tabs__toggle, [data-tabs-toggle]');
    let contents = tab.querySelectorAll('.tabs__content, [data-tabs-content]');
    toggles.forEach(function (toggle) {
        toggle.addEventListener('click', function (e) {
            let id = this.getAttribute('href');
            contents.forEach(function (item) {
                if(id.replace('#', '') === item.id) {
                    item.classList.add('current');
                } else {
                    item.classList.remove('current');
                }
            });
            toggles.forEach(function (item) {
                if(toggle === item) {
                    item.classList.add('current');
                } else {
                    item.classList.remove('current');
                }
            });
            e.preventDefault();
        })
    })
});

// Modals
let modalOpen;
const modalButtons = document.querySelectorAll('.js-modal');
const modalCloseButtons = document.querySelectorAll('.js-modal-close');
modalCloseButtons.forEach(function (button) {
    button.addEventListener('click', function () {
        if(modalOpen) {
            modalOpen.classList.add('visually-hidden');
            modalOpen = null;
        }
    });
});
modalButtons.forEach(function (button) {
    button.addEventListener('click', function (e) {
        if(modalOpen) {
            modalOpen.classList.add('visually-hidden');
        }
        let id = button.getAttribute('href') ?? button.dataset.href;
        let modal = document.querySelector(id);

        if(id === '#order-form') {
            let priceInput = modal.querySelector('.js-input-price'),
                typeInput = modal.querySelector('.js-input-type'),
                dateInput = modal.querySelector('.js-input-date'),
                dateSpan = modal.querySelector('.js-span-date'),
                typeSpan = modal.querySelector('.js-span-type');
            priceInput.value = button.dataset.price;
            typeInput.value = button.dataset.type;
            dateInput.value = button.dataset.date;
            dateSpan.textContent = button.dataset.date;
            typeSpan.textContent = button.dataset.type;
        }

        if(id.includes('#buy-ticket')) {
            let priceInput = modal.querySelector('.js-input-price'),
                timeInput = modal.querySelector('.js-input-time'),
                dateInput = modal.querySelector('.js-input-date'),
                placeInput = modal.querySelector('.js-input-place'),
                typeInput = modal.querySelector('.js-input-type'),

                priceSpan = modal.querySelector('.js-info-price'),
                dateSpan = modal.querySelector('.js-info-date'),
                timeSpan = modal.querySelector('.js-info-time'),
                placeSpan = modal.querySelector('.js-info-place'),
                typeSpan = modal.querySelector('.js-info-type');

            priceInput.value = button.dataset.price;
            timeInput.value = button.dataset.time;
            dateInput.value = button.dataset.date;
            placeInput.value = button.dataset.place;
            typeInput.value = button.dataset.type;

            priceSpan.textContent = button.dataset.price;
            dateSpan.textContent = button.dataset.date;
            timeSpan.textContent = button.dataset.time;
            placeSpan.textContent = button.dataset.place;
            typeSpan.textContent = button.dataset.type;
        }

        modal.classList.remove('visually-hidden');
        modalOpen = modal;

        e.preventDefault();
    });
});
window.modalOpenById = function(id) {
    if(modalOpen) {
        modalOpen.classList.add('visually-hidden');
    }
    modalOpen = document.querySelector(id);
    modalOpen.classList.remove('visually-hidden');
}
window.modalCloseById = function(id, deleteModal) {
    if(modalOpen) {
        modalOpen.classList.add('visually-hidden');
        modalOpen = undefined;
    } else {
        const modal = document.querySelector(id);
        modal.classList.add('visually-hidden');
        if(deleteModal) {
            modal.remove();
        }
    }
}

// Ajax forms
const forms = document.querySelectorAll('.ajax-form');
forms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
        let xhr = new XMLHttpRequest(),
            token = document.querySelector('[name="csrf-token"]').getAttribute('content'),
            url = form.getAttribute('action'),
            data = new FormData(form);

        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
                const data = JSON.parse(xhr.responseText);
                const html = `
                    <div class="modal" id="message">
                      <div class="modal__overlay" onclick="modalCloseById('#message', true)"></div>
                      <div class="modal__inner modal__inner--medium">
                        <button class="modal__close" type="button" onclick="modalCloseById('#message', true)" aria-label="Закрыть модальное окно">
                          <svg><use xlink:href="/assets/img/icons/icons.svg#close"></use></svg>
                        </button>
                        <div class="modal__content">
                            <div class="modal__title">${data.title}</div>
                            <div class="modal__text">${data.message}</div>
                            <div class="form__button form__button--center">
                              <button class="button button--large button--green" onclick="modalCloseById('#message', true)" type="button">Хорошо</button>
                            </div>
                        </div>
                      </div>
                    </div>
                `;
                document.body.insertAdjacentHTML('beforeend', html);
                modalOpen.classList.add('visually-hidden');
                modalOpen = undefined;
                form.reset();
            }
        }
        xhr.open('post', url);
        xhr.setRequestHeader("X-CSRF-Token", token);
        xhr.setRequestHeader("Accept", "application/json");
        xhr.send(data);

        e.preventDefault();
    });
});

// Type consultation
const type = document.querySelector('#type');
const typeOnline = document.querySelector('#type-online');
const skypeInput = document.querySelector('#skype');
const communicationMethod = document.querySelector('#communication_method');
const communicationMethodSkype = document.querySelector('#communication_method-skype');
if(type) {
    type.addEventListener('change', function () {
        if(this.value === 'online') {
            typeOnline.classList.remove('visually-hidden');
            communicationMethod.setAttribute('required', 'required');
        } else {
            typeOnline.classList.add('visually-hidden');
            communicationMethodSkype.classList.add('visually-hidden');
            skypeInput.removeAttribute('required');
            skypeInput.value = '';
            communicationMethod.removeAttribute('required');
            communicationMethod.value = ''
        }
    });
}
if(communicationMethod) {
    communicationMethod.addEventListener('change', function () {
        if(this.value === 'skype') {
            communicationMethodSkype.classList.remove('visually-hidden');
            skypeInput.setAttribute('required', 'required');
        } else {
            communicationMethodSkype.classList.add('visually-hidden');
            skypeInput.removeAttribute('required');
            skypeInput.value = '';
        }
    });
}


// Phone mask
function maskedPhones() {
    const phoneInputs = document.querySelectorAll('input[type="tel"]');
    const getInputNumbersValue = function (input) {
        return input.value.replace(/\D/g, '');
    }
    const onPhonePaste = function (e) {
        let input = e.target,
            inputNumbersValue = getInputNumbersValue(input);
        let pasted = e.clipboardData || window.clipboardData;
        if (pasted) {
            let pastedText = pasted.getData('Text');
            if (/\D/g.test(pastedText)) {
                input.value = inputNumbersValue;
                return;
            }
        }
    }
    const onPhoneInput = function (e) {
        let input = e.target,
            inputNumbersValue = getInputNumbersValue(input),
            selectionStart = input.selectionStart,
            formattedInputValue = "";

        if (!inputNumbersValue) {
            return input.value = "";
        }

        if (input.value.length !== selectionStart) {
            if (e.data && /\D/g.test(e.data)) {
                input.value = inputNumbersValue;
            }
            return;
        }

        if (["7", "8", "9"].indexOf(inputNumbersValue[0]) > -1) {
            if (inputNumbersValue[0] === "9") inputNumbersValue = "7" + inputNumbersValue;
            let firstSymbols = (inputNumbersValue[0] === "8") ? "+7" : "+7";
            formattedInputValue = input.value = firstSymbols + " ";
            if (inputNumbersValue.length > 1) {
                formattedInputValue += '(' + inputNumbersValue.substring(1, 4);
            }
            if (inputNumbersValue.length >= 5) {
                formattedInputValue += ') ' + inputNumbersValue.substring(4, 7);
            }
            if (inputNumbersValue.length >= 8) {
                formattedInputValue += '-' + inputNumbersValue.substring(7, 9);
            }
            if (inputNumbersValue.length >= 10) {
                formattedInputValue += '-' + inputNumbersValue.substring(9, 11);
            }
        } else {
            formattedInputValue = '+' + inputNumbersValue.substring(0, 16);
        }
        input.value = formattedInputValue;
    }
    const onPhoneKeyDown = function (e) {
        let inputValue = e.target.value.replace(/\D/g, '');
        if (e.keyCode === 8 && inputValue.length === 1) {
            e.target.value = "";
        }
    }
    phoneInputs.forEach(function (phoneInput) {
        phoneInput.addEventListener('keydown', onPhoneKeyDown);
        phoneInput.addEventListener('input', onPhoneInput, false);
        phoneInput.addEventListener('paste', onPhonePaste, false);
    });
}
maskedPhones();

// Nav scrolling on events
const navEvents = document.querySelector('.events__nav');
if(navEvents) {
    const currentItem = navEvents.querySelector('.current');
    navEvents.scrollLeft = currentItem.offsetLeft;
}

// Input datepicker
const dateFrom = document.querySelector('[data-date-from]');
const dateTo = document.querySelector('[data-date-to]');
if(dateFrom && dateTo) {
    const datesPickerFrom = new Lightpick({
        field: dateFrom,
        format: 'DD.MM.YYYY',
        separator: '.',
        orientation: 'left',
        dropdowns: {
            years: false,
            months: false,
        },
        onSelect: function(date){
            dateFrom.form.submit()
        }
    });
    const datesPickerTo = new Lightpick({
        field: dateTo,
        format: 'DD.MM.YYYY',
        separator: '.',
        orientation: 'right',
        dropdowns: {
            years: false,
            months: false,
        },
        onSelect: function(date){
            dateTo.form.submit()
        }
    });
}

// Swiper
const swiper = new Swiper('[data-swiper]', {
    slidesPerView: 'auto',
    spaceBetween: 10,
    modules: [Navigation, Grid],
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    direction: 'vertical',
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 15,
            direction: 'horizontal',
            grid: {
                rows: 1
            }
        },
        1024: {
            slidesPerView: 2,
            spaceBetween: 15,
            direction: 'horizontal',
            grid: {
                rows: 1
            }
        },
        1280: {
            slidesPerView: 3,
            spaceBetween: 15,
            direction: 'horizontal',
            grid: {
                rows: 1
            }
        },
        1400: {
            slidesPerView: 3,
            spaceBetween: 18,
            direction: 'horizontal',
            grid: {
                rows: 1
            }
        }
    }
});
